export const PORTAL_DARK_MODE_STORAGE_KEY = 'geclisaPortalDarkMode'

function readRawStoredDarkModePreference() {
  if (typeof localStorage === 'undefined') return null
  const stored = localStorage.getItem(PORTAL_DARK_MODE_STORAGE_KEY)
  if (!stored) return null

  if (stored === 'true' || stored === 'false') {
    return { dark: stored === 'true', systemDarkAtSave: null }
  }

  try {
    const parsed = JSON.parse(stored)
    if (typeof parsed?.dark === 'boolean') {
      return {
        dark: parsed.dark,
        systemDarkAtSave:
          typeof parsed.systemDarkAtSave === 'boolean'
            ? parsed.systemDarkAtSave
            : null,
      }
    }
  } catch (e) {
    return null
  }

  return null
}

export function readStoredDarkModePreference() {
  const stored = readRawStoredDarkModePreference()
  if (!stored) return null

  const systemDark = systemPrefersDarkMode()
  if (stored.systemDarkAtSave !== systemDark) {
    clearDarkModePreference()
    return null
  }

  return stored.dark
}

export function systemPrefersDarkMode() {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
    return false
  }
  return window.matchMedia('(prefers-color-scheme: dark)').matches
}

export function resolveInitialDarkMode() {
  const stored = readStoredDarkModePreference()
  return stored ?? systemPrefersDarkMode()
}

export function saveDarkModePreference(value) {
  if (typeof localStorage === 'undefined') return
  localStorage.setItem(
    PORTAL_DARK_MODE_STORAGE_KEY,
    JSON.stringify({
      dark: !!value,
      systemDarkAtSave: systemPrefersDarkMode(),
    }),
  )
}

export function clearDarkModePreference() {
  if (typeof localStorage === 'undefined') return
  localStorage.removeItem(PORTAL_DARK_MODE_STORAGE_KEY)
}
